import {getLocale} from '@wix/wix-events-commons-statics/dist/locale'
import {AppProps} from '../components/app/interfaces'
import {State} from '../types/state'
import {isRtlEnabled} from './experiments'

const MAX_FULL_WIDTH_MARGIN = 100

export const getFullLocale = (state: State) => getLocale(state.environment.locale, isRtlEnabled(state))

export const getLanguage = (state: State) => state.environment.language

export const isMobile = (state: State) => state.environment.mobile

export const isEditor = (state: State) => state.environment.editor

export const isSite = (state: State) => state.environment.site

export const isFullWidth = (state: State, dimensions: AppProps['dimensions']) => {
  const {width, left} = dimensions

  return isSite(state) ? String(width) === '' : left < MAX_FULL_WIDTH_MARGIN
}
